import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { GeneralName, Extension } from "@peculiar/asn1-x509";
import { Request } from "./request";
import { Version } from "./types";
export class TBSRequest {
    constructor(params = {}) {
        this.version = Version.v1;
        this.requestList = [];
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, context: 0, defaultValue: Version.v1 })
], TBSRequest.prototype, "version", void 0);
__decorate([
    AsnProp({ type: GeneralName, context: 1, optional: true })
], TBSRequest.prototype, "requestorName", void 0);
__decorate([
    AsnProp({ type: Request, repeated: "sequence" })
], TBSRequest.prototype, "requestList", void 0);
__decorate([
    AsnProp({ type: Extension, context: 2, optional: true, repeated: "sequence" })
], TBSRequest.prototype, "requestExtensions", void 0);
